import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { AppRoute } from 'lib/router'
import { AssistantPlaygroundGlobalActions } from 'pages/AssistantPlayground/components'

export const TopNavGlobalActions: FC = () => {
  const location = useLocation()

  const renderContent = () => {
    switch (location.pathname) {
      case AppRoute.AssistantPlayground:
        return <AssistantPlaygroundGlobalActions />
      default:
        return null
    }
  }

  return renderContent()
}
